import React from "react";
import { Box } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { Modal } from "../Modal/Modal";
import { deviceAccess, deviceApproved, deviceApprovedMsg } from "../messages";
import Text from "../text/Text";

const DeviceApprovedModal = ({
  isFromBrowser,
  isModalOpen,
  setIsModalOpen,
}) => {
  const renderBody = () => (
    <Box textAlign="center">
      <CheckCircle className="tick-icon" />
      <Text size={20} font="semibold">
        {deviceApproved}
      </Text>
      <Text
        size={14}
        className="grey-text"
        font="regular"
        sx={{ margin: "8px 0" }}
      >
        {deviceApprovedMsg}
      </Text>
    </Box>
  );

  return (
    <Modal
      maxWidth="xs"
      open={isModalOpen}
      handleClose={() => setIsModalOpen(false)}
      body={renderBody()}
      title={deviceAccess}
      closeIcon
    />
  );
};

export default DeviceApprovedModal;
